export function CheckCircleIcon() {
  return (
    <svg
      width="51"
      height="50"
      viewBox="0 0 51 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="bg-message-ok rounded-full"
    >
      <path
        d="M21.4911 34.0068L13.3661 25.835C12.878 25.3441 12.878 24.5481 13.3661 24.0571L15.1338 22.2791C15.622 21.7882 16.4135 21.7882 16.9016 22.2791L22.375 27.784L34.0984 15.9932C34.5865 15.5023 35.378 15.5023 35.8662 15.9932L37.6339 17.7711C38.122 18.2621 38.122 19.0581 37.6339 19.5491L23.2589 34.0068C22.7707 34.4977 21.9792 34.4977 21.4911 34.0068Z"
        fill="white"
      />
    </svg>
  );
}
